/* Форма смены имени. Стили — копия PasswordChangeForm: та же форма стоит
   рядом в том же попапе настроек, разъезжаться визуально им незачем. */

.form {
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
}

.label {
  color: var(--text-2);
  font-size: var(--fs-sm);
  font-weight: 500;
}

.control {
  width: 100%;
  padding: var(--sp-3) var(--sp-4);
  background: var(--surface);
  border: var(--bw) solid var(--border-strong);
  border-radius: var(--radius-lg);
  font: inherit;
  color: inherit;
}

.buttonRow {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  gap: var(--sp-4);
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 38px;
  padding: var(--sp-3) var(--sp-5);
  border: var(--bw) solid var(--border-strong);
  border-radius: var(--radius-lg);
  background: var(--surface);
  color: inherit;
  font: inherit;
  font-size: var(--fs-md);
  cursor: pointer;
  transition:
    background var(--dnd-dur) var(--dnd-ease),
    box-shadow var(--dnd-dur) var(--dnd-ease);
}

.btn:hover:not(:disabled) {
  background: var(--surface-sunken);
  box-shadow: var(--glow-accent);
}

.btn:focus-visible {
  box-shadow: var(--focus-ring), var(--glow-accent-strong);
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btnPrimary {
  background: var(--btn-primary-bg);
  border-color: var(--btn-primary-bg);
  color: var(--btn-primary-fg);
  box-shadow: var(--glow-edge);
}

.btnPrimary:hover:not(:disabled) {
  background: var(--btn-primary-hover);
  border-color: var(--btn-primary-hover);
  box-shadow: var(--glow-edge), var(--glow-primary);
}

.notice {
  margin: 0;
  padding: var(--sp-4) var(--sp-5);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius-lg);
  background: var(--surface-sunken);
  color: var(--text-2);
  font-size: var(--fs-sm);
}

.error {
  margin: 0;
  padding: var(--sp-4) var(--sp-5);
  border: var(--bw) solid var(--error-border);
  border-radius: var(--radius-lg);
  background: var(--error-bg);
  color: var(--error);
  box-shadow: var(--glow-error);
  font-size: var(--fs-sm);
}

/* ── Телефон (порог продублирован в ui/shell/useIsMobile.ts) ─────────────── */
@media (max-width: 720px) {
  .btn {
    min-height: 44px;
  }
}
